import ENV from "config/Env";
import { typedQueryClient, usePermanentRealTimeUser, useTypedMutation } from "hooks";
import { useRedirectToLandingPage } from "modules/Login/hooks";
import { PrivacyAndSecurityQueryKeys } from "modules/PrivacyAndSecurityDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useAcceptDpoContractMutation = () => {
  const { user } = usePermanentRealTimeUser();
  const redirectToLandingPage = useRedirectToLandingPage();

  return useTypedMutation<void, void>({
    mutationFn: async () => (await ApiInstance.post("/agreements/privacy/accept", { dealer_id: user?.dealer_id }, ENV.dealerBaseURL)).data,
    onSuccess: () => {
      const privacyAndSecurityStatus = typedQueryClient.getQueryData(PrivacyAndSecurityQueryKeys.status);
      if (!privacyAndSecurityStatus) return;

      typedQueryClient.setQueryData(PrivacyAndSecurityQueryKeys.status, { ...privacyAndSecurityStatus, signed: true });
      redirectToLandingPage();
    }
  });
};
